// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  min-height: 100vh;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  padding: 0;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}

.welcome-section {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.05) 100%
  );
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 60px 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.welcome-section::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, #f9faff 0%, #ffffff 100%);
}

.welcome-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
}

.welcome-icon {
  font-size: 4rem;
  color: #ffffff;
  margin-bottom: 20px;
  opacity: 0.9;
}

.welcome-title {
    font-size: 2.3rem;
    font-weight: 800;
    color: #dc641a;
    /* margin-bottom: 15px; */
    line-height: 1.2;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.brand-name {
    background: linear-gradient(45deg, #dc641a, #dc641a, #dc641a, #d15f19, #dc641a);
    background-size: 300% 300%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: gradientShift 3s ease-in-out infinite;
}

@keyframes gradientShift {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.welcome-subtitle {
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 30px;
  font-weight: 400;
}

.role-badge {
  display: inline-block;
  margin-top: 10px;
}

.role-indicator {
  padding: 12px 24px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.role-indicator.admin {
    background: linear-gradient(166deg, rgb(255 107 107), rgb(220 100 26));
    color: #ffffff;
}

.role-indicator.employee {
  background: linear-gradient(
    135deg,
   rgb(78 205 196),
   rgb(255 107 107)
  );
  color: #ffffff;
}

.dashboard-section {
  padding: 60px 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  font-size: 2.5rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 15px;
}

.section-icon {
  font-size: 2.2rem;
  color: #4ecdc4;
}

.section-description {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
  max-width: 600px;
  margin: 0 auto;
}

.modules-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.module-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 30px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.module-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--card-color);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.module-card:hover::before {
  transform: scaleX(1);
}

.module-card:hover {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.module-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.module-icon-wrapper {
  width: 70px;
  height: 70px;
  border-radius: 18px;
  background: var(--card-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.module-card:hover .module-icon-wrapper {
  transform: scale(1.1) rotate(5deg);
}

.module-icon {
  font-size: 2rem;
  color: var(--card-color);
}

.module-badge {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--card-color);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 0.8rem;
}

.module-content {
  margin-bottom: 25px;
}

.module-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 8px;
  line-height: 1.3;
}

.module-description {
  color: #718096;
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
}

.module-footer {
  display: flex;
  justify-content: flex-end;
}

.module-action {
  color: var(--card-color);
  font-weight: 600;
  font-size: 0.9rem;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s ease;
}

.module-card:hover .module-action {
  opacity: 1;
  transform: translateX(0);
}

.stats-section {
  margin-top: 40px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 25px;
  display: flex;
  align-items: center;
  gap: 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.stat-icon {
  font-size: 2.5rem;
  color: #4ecdc4;
}

.stat-content h4 {
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 5px 0;
  font-size: 0.9rem;
  font-weight: 500;
}

.stat-number {
  color: #ffffff;
  font-size: 1.8rem;
  font-weight: 700;
}

.no-access-section {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 60px 20px;
}

.no-access-content {
  text-align: center;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 50px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.no-access-icon {
  font-size: 4rem;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 20px;
}

.no-access-content h3 {
  color: #ffffff;
  font-size: 1.8rem;
  margin-bottom: 15px;
  font-weight: 600;
}

.no-access-content p {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 30px;
  font-size: 1.1rem;
}

.login-prompt-btn {
  background: linear-gradient(135deg, #4ecdc4, #44a08d);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.login-prompt-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

/* Responsive Design */
@media (max-width: 768px) {
  .welcome-title {
    font-size: 2.5rem;
  }

  .section-title {
    font-size: 2rem;
    flex-direction: column;
    gap: 10px;
  }

  .modules-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .module-card {
    padding: 25px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .welcome-section {
    padding: 40px 15px;
  }

  .welcome-title {
    font-size: 2rem;
  }

  .dashboard-section {
    padding: 40px 15px;
  }

  .module-card {
    padding: 20px;
  }

  .no-access-content {
    padding: 30px 20px;
  }
  .brand-section {
    margin-right: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/Home.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mEAAmE;EACnE,UAAU;EACV,mEAAmE;AACrE;;AAEA;EACE;;;;GAIC;EACD,2BAA2B;EAC3B,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,6DAA6D;AACjE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,yCAAyC;AAC7C;AACA;IACI,+EAA+E;IAC/E,0BAA0B;IAC1B,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;IACI,sEAAsE;IACtE,cAAc;AAClB;;AAEA;EACE;;;;GAIC;EACD,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,4DAA4D;EAC5D,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6BAA6B;EAC7B,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".home-container {\n  min-height: 100vh;\n  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */\n  padding: 0;\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.welcome-section {\n  background: linear-gradient(\n    135deg,\n    rgba(255, 255, 255, 0.1) 0%,\n    rgba(255, 255, 255, 0.05) 100%\n  );\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 60px 20px;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.welcome-section::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(135deg, #f9faff 0%, #ffffff 100%);\n}\n\n.welcome-content {\n  position: relative;\n  z-index: 1;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.welcome-icon {\n  font-size: 4rem;\n  color: #ffffff;\n  margin-bottom: 20px;\n  opacity: 0.9;\n}\n\n.welcome-title {\n    font-size: 2.3rem;\n    font-weight: 800;\n    color: #dc641a;\n    /* margin-bottom: 15px; */\n    line-height: 1.2;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n.brand-name {\n    background: linear-gradient(45deg, #dc641a, #dc641a, #dc641a, #d15f19, #dc641a);\n    background-size: 300% 300%;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    animation: gradientShift 3s ease-in-out infinite;\n}\n\n@keyframes gradientShift {\n  0%,\n  100% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n\n.welcome-subtitle {\n  font-size: 1.3rem;\n  color: rgba(255, 255, 255, 0.9);\n  margin-bottom: 30px;\n  font-weight: 400;\n}\n\n.role-badge {\n  display: inline-block;\n  margin-top: 10px;\n}\n\n.role-indicator {\n  padding: 12px 24px;\n  border-radius: 50px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n.role-indicator.admin {\n    background: linear-gradient(166deg, rgb(255 107 107), rgb(220 100 26));\n    color: #ffffff;\n}\n\n.role-indicator.employee {\n  background: linear-gradient(\n    135deg,\n   rgb(78 205 196),\n   rgb(255 107 107)\n  );\n  color: #ffffff;\n}\n\n.dashboard-section {\n  padding: 60px 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 50px;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 15px;\n}\n\n.section-icon {\n  font-size: 2.2rem;\n  color: #4ecdc4;\n}\n\n.section-description {\n  font-size: 1.1rem;\n  color: rgba(255, 255, 255, 0.8);\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.modules-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 30px;\n  margin-bottom: 60px;\n}\n\n.module-card {\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 20px;\n  padding: 30px;\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  position: relative;\n  overflow: hidden;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n}\n\n.module-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(--card-color);\n  transform: scaleX(0);\n  transition: transform 0.3s ease;\n}\n\n.module-card:hover::before {\n  transform: scaleX(1);\n}\n\n.module-card:hover {\n  transform: translateY(-10px) scale(1.02);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n.module-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n.module-icon-wrapper {\n  width: 70px;\n  height: 70px;\n  border-radius: 18px;\n  background: var(--card-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.module-card:hover .module-icon-wrapper {\n  transform: scale(1.1) rotate(5deg);\n}\n\n.module-icon {\n  font-size: 2rem;\n  color: var(--card-color);\n}\n\n.module-badge {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: var(--card-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n\n.module-content {\n  margin-bottom: 25px;\n}\n\n.module-title {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin-bottom: 8px;\n  line-height: 1.3;\n}\n\n.module-description {\n  color: #718096;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.module-footer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.module-action {\n  color: var(--card-color);\n  font-weight: 600;\n  font-size: 0.9rem;\n  opacity: 0;\n  transform: translateX(-10px);\n  transition: all 0.3s ease;\n}\n\n.module-card:hover .module-action {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.stats-section {\n  margin-top: 40px;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 16px;\n  padding: 25px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.stat-icon {\n  font-size: 2.5rem;\n  color: #4ecdc4;\n}\n\n.stat-content h4 {\n  color: rgba(255, 255, 255, 0.9);\n  margin: 0 0 5px 0;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.stat-number {\n  color: #ffffff;\n  font-size: 1.8rem;\n  font-weight: 700;\n}\n\n.no-access-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  padding: 60px 20px;\n}\n\n.no-access-content {\n  text-align: center;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 50px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.no-access-icon {\n  font-size: 4rem;\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 20px;\n}\n\n.no-access-content h3 {\n  color: #ffffff;\n  font-size: 1.8rem;\n  margin-bottom: 15px;\n  font-weight: 600;\n}\n\n.no-access-content p {\n  color: rgba(255, 255, 255, 0.8);\n  margin-bottom: 30px;\n  font-size: 1.1rem;\n}\n\n.login-prompt-btn {\n  background: linear-gradient(135deg, #4ecdc4, #44a08d);\n  color: white;\n  border: none;\n  padding: 15px 30px;\n  border-radius: 50px;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.login-prompt-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .welcome-title {\n    font-size: 2.5rem;\n  }\n\n  .section-title {\n    font-size: 2rem;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .modules-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .module-card {\n    padding: 25px;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .welcome-section {\n    padding: 40px 15px;\n  }\n\n  .welcome-title {\n    font-size: 2rem;\n  }\n\n  .dashboard-section {\n    padding: 40px 15px;\n  }\n\n  .module-card {\n    padding: 20px;\n  }\n\n  .no-access-content {\n    padding: 30px 20px;\n  }\n  .brand-section {\n    margin-right: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
